import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

import '../../components/cartoon/cartoon.css';
import { LoopLogo } from '../../components/cartoon/Art';
import { contact, talkLink } from '../../components/cartoon/links';
import { POLICIES, POLICIES_UPDATED_AT } from './content';

const textStyle = { maxWidth: 'none', marginTop: 12 };

function Section({ heading, body }) {
    return (
        <section style={{ marginTop: 40 }}>
            <h2 style={{ fontSize: 24, fontWeight: 700 }}>{heading}</h2>
            {body.map((block) => (Array.isArray(block)
                ? (
                    <ul key={block[0]} className="lc-text" style={{ ...textStyle, paddingLeft: 24 }}>
                        {block.map((item) => <li key={item} style={{ marginTop: 6 }}>{item}</li>)}
                    </ul>
                )
                : <p key={block} className="lc-text" style={textStyle}>{block}</p>))}
        </section>
    );
}

export default function PolicyPage({ policy }) {
    useEffect(() => { window.scrollTo(0, 0); }, [policy.path]);

    return (
        <div className="lc bg-preto" style={{ minHeight: '100vh' }}>
            <header className="lc-wrap" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: 24 }}>
                <Link to="/" aria-label="Loop Coffee, página inicial" style={{ width: 150 }}><LoopLogo /></Link>
                <Link to="/" style={{ color: '#fff', fontWeight: 700 }}>← voltar à loja</Link>
            </header>
            <main className="lc-wrap" style={{ paddingTop: 48, paddingBottom: 80, maxWidth: 840 }}>
                <span className="lc-pill">políticas</span>
                <h1 className="lc-title">{policy.title}<span className="lc-dot">.</span></h1>
                <p style={{ marginTop: 16, color: '#bbb' }}>Atualizada em {POLICIES_UPDATED_AT}</p>
                <p className="lc-text" style={{ maxWidth: 'none' }}>{policy.intro}</p>
                {policy.sections.map((section) => <Section key={section.heading} {...section} />)}
                <section style={{ marginTop: 40 }}>
                    <h2 style={{ fontSize: 24, fontWeight: 700 }}>Contato</h2>
                    <p className="lc-text" style={textStyle}>
                        E-mail <a href={contact.emailHref} style={{ color: 'var(--lc-lil)' }}>{contact.email}</a> ou
                        WhatsApp <a href={talkLink} target="_blank" rel="noopener noreferrer" style={{ color: 'var(--lc-lil)' }}>{contact.phone}</a>,
                        {' '}{contact.hours.toLowerCase()}.
                    </p>
                </section>
                <nav aria-label="Outras políticas" style={{ marginTop: 56 }}>
                    <div className="lc-rule" />
                    <ul style={{ listStyle: 'none', padding: 0, display: 'flex', flexWrap: 'wrap', gap: '12px 28px' }}>
                        {POLICIES.filter((other) => other.path !== policy.path).map((other) => (
                            <li key={other.path}><Link to={other.path} style={{ color: '#fff' }}>{other.label}</Link></li>
                        ))}
                    </ul>
                </nav>
            </main>
        </div>
    );
}
